import React from "react";

export const GeometrixLoading: React.FC = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', flexDirection: 'column' }}>
    <img
      src="/assets/images/logo.png"
      alt="Geometrix Logo"
      style={{ height: 48, marginBottom: 24 }}
    />
    <div style={{
      border: '6px solid #f3f3f3',
      borderTop: '6px solid #FFD700', // gold
      borderRadius: '50%',
      width: 48,
      height: 48,
      animation: 'spin 1s linear infinite',
      marginBottom: 16
    }} />
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);
